"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Textbox = exports.SummaryItem = exports.SummaryFootnote = exports.SummaryDetails = exports.Summary = exports.Section = exports.ScrollableArea = exports.MultilineTextbox = exports.Heading = exports.Header = exports.Footnote = exports.FooterSection = exports.CampaignQuestion = exports.AnswerButtons = exports.AnswerButton = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _FadingOverflow = _interopRequireDefault(require("../FadingOverflow"));
var _palette = require("../../styles/palette");
var _vars = require("../../styles/vars");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var CampaignQuestion = exports.CampaignQuestion = _styledComponents["default"].div.withConfig({
  displayName: "styles__CampaignQuestion",
  componentId: "sc-1qjw0mr-0"
})(["", ";background:#fff;border-radius:", "px;display:flex;flex-direction:column;height:100%;"], (0, _vars.cardShadowCss)(false), function (p) {
  return _vars.borderRadius[p.device];
});
var ScrollableArea = exports.ScrollableArea = (0, _styledComponents["default"])(_FadingOverflow["default"]).withConfig({
  displayName: "styles__ScrollableArea",
  componentId: "sc-1qjw0mr-1"
})(["flex-grow:1;.FadingOverlay__InnerWrapper{display:flex;flex-direction:column;height:100%;padding:", ";}"], function (p) {
  return p.device === 'desktop' ? '32px 32px 0' : '16px 16px 0';
});
var Section = exports.Section = _styledComponents["default"].div.withConfig({
  displayName: "styles__Section",
  componentId: "sc-1qjw0mr-2"
})(["flex-shrink:0;", ""], function (p) {
  return p.stretch && 'flex-grow: 1';
});
var Header = exports.Header = _styledComponents["default"].header.withConfig({
  displayName: "styles__Header",
  componentId: "sc-1qjw0mr-3"
})(["font-size:", "px;line-height:24px;opacity:0.54;margin:0 0 8px;"], function (p) {
  return p.device === 'desktop' ? 16 : 14;
});
var Heading = exports.Heading = _styledComponents["default"].h2.withConfig({
  displayName: "styles__Heading",
  componentId: "sc-1qjw0mr-4"
})(["font-weight:normal;", ""], function (p) {
  return p.device === 'desktop' ? "\n        font-size: 24px;\n        line-height: 32px;\n        margin: 0 0 24px;\n      " : "\n        font-size: 16px;\n        line-height: 24px;\n        margin: 0 0 16px;\n      ";
});
var AnswerButtons = exports.AnswerButtons = _styledComponents["default"].div.withConfig({
  displayName: "styles__AnswerButtons",
  componentId: "sc-1qjw0mr-5"
})(["", ""], function (p) {
  return p.device === 'desktop' && "\n      display: flex;\n      min-height: 92px;\n    ";
});
var AnswerButton = exports.AnswerButton = _styledComponents["default"].button.attrs({
  type: 'button'
}).withConfig({
  displayName: "styles__AnswerButton",
  componentId: "sc-1qjw0mr-6"
})(["background:", ";border:0;color:#000;cursor:pointer;display:block;font-family:inherit;outline:0;text-align:center;", " ", " + ", "{", "}}"], _palette.commonPalette.darkestGray, function (p) {
  return p.device === 'desktop' ? "\n        flex-basis: 0;\n        flex-grow: 1;\n        font-size: 14px;\n        line-height: 20px;\n        padding: 8px;\n      " : "\n        font-size: 12px;\n        line-height: 40px;\n        padding: 0 8px;\n        white-space: nowrap;\n        width: 100%;\n      ";
}, function (p) {
  return p.isSelected && "\n      background: ".concat(_palette.commonPalette.txBlack, ";\n      color: #fff;\n    ");
}, function () {
  return AnswerButton;
}, function (p) {
  return p.device === 'desktop' ? 'margin-left: 16px' : 'margin-top: 4px';
});
var Summary = exports.Summary = _styledComponents["default"].dl.withConfig({
  displayName: "styles__Summary",
  componentId: "sc-1qjw0mr-7"
})(["margin:0;"]);
var SummaryItem = exports.SummaryItem = _styledComponents["default"].dd.withConfig({
  displayName: "styles__SummaryItem",
  componentId: "sc-1qjw0mr-8"
})(["font-size:12px;line-height:16px;margin:0 0 8px;opacity:0.6;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"]);
var SummaryDetails = exports.SummaryDetails = _styledComponents["default"].dt.withConfig({
  displayName: "styles__SummaryDetails",
  componentId: "sc-1qjw0mr-9"
})(["font-size:14px;line-height:16px;margin:", ";"], function (p) {
  return p.device === 'desktop' ? '0 0 8px' : '0 0 12px';
});
var SummaryFootnote = exports.SummaryFootnote = _styledComponents["default"].footer.withConfig({
  displayName: "styles__SummaryFootnote",
  componentId: "sc-1qjw0mr-10"
})(["font-size:10px;line-height:16px;opacity:0.34;margin:8px 0 0;"]);
var Textbox = exports.Textbox = _styledComponents["default"].input.attrs({
  type: 'text'
}).withConfig({
  displayName: "styles__Textbox",
  componentId: "sc-1qjw0mr-11"
})(["background:#fff;border:1px solid ", ";border-radius:3px;color:#000;display:block;font-family:inherit;font-size:14px;line-height:20px;outline:0;padding:10px 16px;width:100%;&::placeholder{color:rgba(0,0,0,0.5);}"], _palette.commonPalette.borderGrey);
var MultilineTextbox = exports.MultilineTextbox = (0, _styledComponents["default"])(Textbox.withComponent('textarea')).attrs({
  rows: 4
}).withConfig({
  displayName: "styles__MultilineTextbox",
  componentId: "sc-1qjw0mr-12"
})(["resize:none;"]);
var Footnote = exports.Footnote = _styledComponents["default"].footer.withConfig({
  displayName: "styles__Footnote",
  componentId: "sc-1qjw0mr-13"
})(["font-size:10px;line-height:", "px;opacity:0.34;margin:24px 0 0;"], function (p) {
  return p.device === 'desktop' ? 14 : 16;
});
var FooterSection = exports.FooterSection = _styledComponents["default"].div.withConfig({
  displayName: "styles__FooterSection",
  componentId: "sc-1qjw0mr-14"
})(["padding:", ";"], function (p) {
  return p.device === 'desktop' ? '8px 32px 32px' : '8px 16px 16px';
});
//# sourceMappingURL=styles.js.map